import React from 'react';
import { useSelector } from 'react-redux';

import ResponsiveToggleGroup from 'src/component/UI/ResponsiveToggleGroup';

import { getUnits } from 'src/module/filter/selector';

export default function UnitSelector () {
  const units = useSelector(getUnits);

  return (
    <div data-testid='unit-selector'>
      <ResponsiveToggleGroup
        buttons={units}
        mainLabel='All' />
    </div>
  );
}

UnitSelector.propTypes = {
};

UnitSelector.defaultProps = {
};
